import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Chips from 'components/field/Chips';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

import StoreName from '../Fields/StoreName';
import TestConnectionButton from '../Fields/TestConnectionButton';
import * as S from '../SalesChannel.styled';

const FoodicsForm = () => {
	const { t } = useTranslation();
	const formMethods = useFormContext();
	const { salesChannel } = useSelector((state) => state.salesChannel);

	const {
		setValue,
		watch,
		formState: { isSubmitting, isLoading: isFormLoading }
	} = formMethods;

	const isLoading = isSubmitting || isFormLoading;
	return (
		<S.StoreAccordion header="storeDetails" defaultVisible>
			<StoreName isLoading={isLoading} />
			<FormItem label="accountId" isLoading={isLoading} required>
				<StringInput name="username" placeholder={t('fieldPlaceholder', { name: t('accountId') })} />
			</FormItem>
			<FormItem label="accessToken" isLoading={isLoading} required>
				<StringInput name="token" placeholder={t('fieldPlaceholder', { name: t('accessToken') })} />
			</FormItem>
			{salesChannel?.slug === 'foodics-delivery' && (
				<>
					<FormItem label="orderTag" isLoading={isLoading}>
						<Chips
							name="statuses"
							value={watch('statuses')}
							setValue={(value) => {
								setValue(`statuses`, value ?? null, { shouldValidate: true, shouldDirty: true });
							}}
							placeholder={t('fieldPlaceholder', { name: t(`filterByStatuses`) })}
						/>
					</FormItem>
					{salesChannel?.testable && <TestConnectionButton />}
				</>
			)}
		</S.StoreAccordion>
	);
};
export default FoodicsForm;
